// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"712":"405755f9","787":"6653abfd"}[chunkId] + ".chunk.js";
};